/* global Iugu */
import { isProduction } from '@/mixins/meta.js'
import { Promise } from 'bluebird'

export const getIuguService = () => {
  if (!Iugu) throw Error('Iugu service not found')

  Iugu.setAccountID(process.env.VUE_APP_IUGU_KEY)
  Iugu.setTestMode(!isProduction())
  Iugu.setup()

  return Iugu
}

const getCardInfo = cardInfo => {
  return {
    number: cardInfo.cardNumber.replace(/\s/g, ''),
    expirationMounth: cardInfo.cardValidate.split('/')[0],
    expirationYear: cardInfo.cardValidate.split('/')[1],
    firstName: cardInfo.cardName.split(' ')[0],
    lastName: cardInfo.cardName
      .split(' ')
      .slice(1)
      .join(' '),
    cvv: cardInfo.cvv,
  }
}

export const createPaymentToken = cardInfo => {
  const card = getCardInfo(cardInfo)
  const iugu = getIuguService()
  const creditCard = iugu.CreditCard(...Object.values(card))

  if (!creditCard.valid()) throw new Error('INVALID_CARD')

  return new Promise((resolve, reject) => {
    iugu.createPaymentToken(creditCard, r => {
      if (!r.errors) return resolve(r)
      reject(new Error('INVALID_CARD'))
    })
  })
}

export const validateCardNumber = value =>
  getIuguService().utils.validateCreditCardNumber(value)
export const validateExpiration = date =>
  getIuguService().utils.validateExpiration(...date.split('/'))
export const validateCVV = (cvv, number) => {
  const num = number || ''
  const utils = getIuguService().utils
  return utils.validateCVV(cvv, utils.getBrandByCreditCardNumber(num))
}
export default {
  validateCardNumber,
  validateExpiration,
  createPaymentToken,
}
